let baseURL, postelURL;
switch(process.env.REACT_APP_ENV) {
  default:
  case 'development':
    baseURL = 'https://test-apiu400.dufercoenergia.com/api/v4.0';
    // baseURL = 'http://10.0.208.122:50151/api/v4.0';
    postelURL = 'https://test-localization.dufercoenergia.com';
    break;
  case 'test':
    baseURL = 'https://test-apiu400.dufercoenergia.com/api/v4.0';
    postelURL = 'https://test-localization.dufercoenergia.com';
    break;
  case 'staging':
    baseURL = 'https://test-apiu400.dufercoenergia.com/api/v4.0';
    postelURL = 'https://test-localization.dufercoenergia.com';
    break;
  case 'production':
    baseURL = 'https://prod-apiu400.dufercoenergia.com/api/v4.0';
    postelURL = 'https://localization.dufercoenergia.com';
    break;
}

export { baseURL, postelURL };
